
import { EventBus, EventTypes } from '../../consts/const-event-types';
import { getEndpoint } from '../../services/service-some-api';

export const returnCustomLegend = (el, legendMultiSelect, ) =>
  { 
    const getOrCreateLegendList = (id) =>
    {
      const legendContainer = el.querySelector(`.${id}`);
      let listContainer = legendContainer.querySelector('ul');
    
      if (!listContainer) {
        listContainer = document.createElement('ul');
        legendContainer.appendChild(listContainer);
      }
    
      return listContainer;
    };
      
    const htmlLegendPlugin = 
    {
      id: 'htmlLegend',
      afterUpdate(chart, args, options)
      {

        const ul = getOrCreateLegendList(options.containerID);
    
        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }
    
        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
    
        items.forEach(item => 
        {

          const li = document.createElement('li');
      

          item.hidden == false ? li.classList.add("selected") : li.classList.remove("selected");
    
          li.addEventListener("click", (evt) => 
          {
            // Don't allow a click event to happen on the tooltip itself
            var allowedClick = evt.target.querySelector(".element-tooltip");

            if(allowedClick)
            {
              const { type } = chart.config;

              if(legendMultiSelect == false || type === 'pie' || type === 'doughnut')
              {
                // Pie and doughnut charts only have a single dataset and visibility is per item
                if(type === 'pie' || type === 'doughnut')
                {
                  chart.toggleDataVisibility(item.index);
                }
                else
                {
                  // Hides all other datasets but the one you click ons
                  chart.data.datasets.forEach((d, index) => 
                  {
                    if(item.datasetIndex != index)
                      chart.setDatasetVisibility(index, false);
                    else
                      chart.setDatasetVisibility(index, true);
                  });
                }
              }
              else
              {
                chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
              }
  
              chart.update();
  
              // create your own event-types for component-to-component communication (fx. this event will be picked up by Header.js component):
              const eventData = 
              {
                detail: { chartElement: el }
              }
              const ev = new CustomEvent(EventTypes.CHART_LEGEND_UPDATE, eventData);
              EventBus.dispatchEvent(ev);
            }

          
          });

          li.setAttribute("data-legend-name", item.text)
    
          li.innerHTML = `
          <span class="legend-color" style="background-color: ${item.fillStyle};"></span>
          ${item.text}
          
          `;
        
          ul.appendChild(li);




        });


        // Send message to load tooltips if any
        const eventData = 
        {
          detail: { chartElement: el }
        }
        const ev = new CustomEvent(EventTypes.CHART_LEGEND_RENDERING_DONE, eventData);
        EventBus.dispatchEvent(ev);
      }
    };

    return htmlLegendPlugin;
};


export const renderLegendTooltips = (el, tooltipsData) =>
{ 
    const legendContainer = el.querySelector(".legend-container");
      
    const tooltipKeys = Object.keys(tooltipsData.tooltips);

    tooltipKeys && tooltipKeys.forEach(key => 
    {
      const legendItem = legendContainer.querySelector(`[data-legend-name="${key}"]`);

      if(legendItem && !legendItem.querySelector(".element-tooltip"))
      {
        const template = `
        <div class="tooltip-content">
        ${tooltipsData.tooltips[key]}
        </div>
        `;

        const div = document.createElement('div');
        div.className = "element-tooltip";
        div.innerHTML = template;

        legendItem.appendChild(div);
      }        
    });
};







